/**
 * Тексты для сцен 1-3 (карточки-сообщения) и сцены 4 (лавина).
 * Тон: реальная неформальная переписка, без маркетингового лака.
 * Атрибуция (caption) сделана так, чтобы один взгляд давал понять источник.
 */

export type ChatMessage = {
  text: string;
  senderName: string;
  senderInitial: string;     // буква-плейсхолдер вместо аватара
  senderColor: string;       // фон аватара
  caption: string;           // мелкая подпись под именем
  time: string;              // подпись времени у баббла
};

export const FORREST: ChatMessage = {
  text: 'глянь — Форест Гамп. я ревела',
  senderName: 'Маша',
  senderInitial: 'М',
  senderColor: '#e57b7b',
  caption: 'в личке · март',
  time: '14:23',
};

export const BOOK_1984: ChatMessage = {
  text: '«1984» Оруэлла. сейчас читать особенно',
  senderName: 'Книги до 30',
  senderInitial: 'К',
  senderColor: '#5a7558',
  caption: 'канал в телеграме',
  time: 'вчера',
};

export const PANCAKES: ChatMessage = {
  text:
    'тонкие блинчики на кефире, как ты любишь:\n' +
    'кефир 500 мл, мука 1.5 ст, яйцо, сахар 2 ст. л., щепотка соды.\n' +
    'жарь без масла, на сухой сковороде.',
  senderName: 'мама',
  senderInitial: 'м',
  senderColor: '#d49a3f',
  caption: 'whatsapp · 12:08',
  time: '12:08',
};

/**
 * AVALANCHE — короткие реплики разных источников.
 * Должны звучать как настоящие сохранёнки: рекомендации, задачи,
 * рилсы, промпты, заметки самому себе. ~40 штук, в сцене 4
 * рандомизируем позицию/поворот/масштаб. На мобильном берём первые 28.
 */
export const AVALANCHE: string[] = [
  'Форест Гамп — глянь обязательно',
  '1984, Оруэлл',
  'блинчики на кефире',
  'это видео разрывает',
  'кофейня Прокуратор, рядом с тобой',
  'Hollow Knight за 200₽',
  'канал про дизайн интерьеров',
  'помнишь книжку, которую обсуждали?',
  'промпт для chatgpt: саммари статьи',
  'сейв этот рецепт, потом сделаем',
  'послушай его новый трек',
  'рилс — в голос',
  'тот фильм мы говорили, забыл название',
  'статья про сон и продуктивность',
  'идея для презы на пятницу',
  'Хичкок — Окно во двор',
  'распродажа в Стиме',
  'выставка в Замостье до 30 марта',
  'пропусти через chatgpt: «выдели тезисы»',
  'это про что мы вчера говорили',
  'досмотреть Severance',
  'сделать отчёт за квартал',
  'погладить рубашку',
  'купить лук на ужин',
  'что почитать сыну?',
  'ответить Маше про дачу',
  'уроки рисования от @illustrator',
  'идея для подкаста',
  'kinopoisk.ru/film/...',
  'кавер исполнитель — найти',
  'игра, в которую играл Антон',
  'паста с лососем — рецепт',
  'tg-канал про путешествия',
  'купить билет на концерт',
  'попробовать новую кофейню',
  'выучить shortcut в figma',
  'заказать книгу на озоне',
  'снять видео для рилса',
  'сходить в музей в выходные',
  'промпт для midjourney',
];
